import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import Work from "@/components/Work";
import DigitalIllustration from "@/components/DigitalIllustration";
import GraphicDesign from "@/components/GraphicDesign";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { LightboxProvider } from "@/components/LightboxContext";

export default function Portfolio() {
  return (
    <LightboxProvider>
      <main className="relative" data-testid="portfolio-page">
        <Navbar />
        <Hero />
        <MarqueeStrip />
        <Work />
        <section
          id="illustrations"
          className="relative py-24 md:py-40 border-t border-[var(--ink)] bg-white overflow-hidden"
          data-testid="illustrations-section"
        >
          <div className="relative max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20">
            <DigitalIllustration />
          </div>
        </section>
        <GraphicDesign />
        <About />
        <Contact />
        <Footer />
      </main>
    </LightboxProvider>
  );
}
